import { render, staticRenderFns } from "./ConfirmStep.vue?vue&type=template&id=96804758&scoped=true&"
import script from "./ConfirmStep.vue?vue&type=script&lang=ts&"
export * from "./ConfirmStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96804758",
  null
  
)

export default component.exports